import { services } from './constants';

export class ContextBuilder {
	constructor() {
		this._user = null;
		this._environment = null;
		this._services = {};
		this._resources = [];
		this._scopedActions = null;
		this._notScopedActions = [
			'bravas.accessControl.license.detailed.getPaginated',
			'bravas.accessControl.license.detailed.exportCsv',
			'bravas.accessControl.license.statesCount',
			'bravas.accessControl.license.analytics',
			'bravas.accessControl.license.discountReason.*',
			'bravas.accessControl.license.type.*',
			'bravas.accessControl.license.feature.*',
			'bravas.accessControl.license.calculate',
			'bravas.accessControl.license.billing.*',
			'bravas.accessControl.license.association',
			'bravas.accessControl.license.history',
			'bravas.accessControl.license.action',
			'bravas.accessControl.license.payment.*',
			'bravas.accessControl.license.changeFeatures',
			'bravas.accessControl.license.block',
			'bravas.accessControl.license.unblock',
			'bravas.accessControl.license.suspend',
			'bravas.accessControl.license.rename',
			// 'bravas.accessControl.license.getByOrganization',
			// 'bravas.accessControl.license.getWithAccess',
			'bravas.accessControl.license.getById',
			'bravas.accessControl.license.create',
			'bravas.accessControl.license.update',
			'bravas.accessControl.license.delete',
		];
	}

	setUser(user) {
		this._user = user;
		return this;
	}

	setEnvironment(environment) {
		this._environment = {
			...environment,
			currentDate: new Date(),
		};
		return this;
	}

	setScopedActions(scopedActions) {
		this._scopedActions = scopedActions;
		return this;
	}

	addServices(owner) {
		this._services = {
			...this._services,
			[owner]: services.get(owner),
		};
		return this;
	}

	setResources(resources) {
		this._resources = resources;
		return this;
	}

	build() {
		return {
			user: this._user,
			environment: this._environment,
			services: this._services,
			resources: this._resources,
			scopedActions: this._scopedActions,
			notScopedActions: this._notScopedActions,
		};
	}
}
